<template>
    <div>
        <el-row type="flex" justify="center" class="notfound">
            <el-col :span="12">
                <div style="text-align:center;">
                    <i class="layui-icon layui-icon-404" style="font-size: 280px;"></i>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name:'NotFound'
}
</script>

<style scoped>
.notfound {
    height: 500px;
}
</style>